import * as React from "react";
import { useSelector } from "react-redux";

import { Button } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { ActiveTaskAction } from "../ActiveTaskAction";
import { ApplicationState } from "../../../applicationState";
import { taskIdSelector } from "../../selectors";

import { CreateRecallModal } from "./CreateRecallModal";

import { Link } from "redux-little-router";

interface OwnProps {
    task: TaskModel;
}

export const CreateRecallButton: React.FunctionComponent<OwnProps> = (props: OwnProps) => {

    const isModalOpen = useSelector((state: ApplicationState) => taskIdSelector(state) === props.task.id);
    const route = useSelector((state: ApplicationState) => state.router.pathname);
    const actionableTasksRoute = "/actionableTasks";
    const isActionableTasksView = route?.startsWith(actionableTasksRoute);

    if (isActionableTasksView) {
        const customerId = props.task.customer.id;
        const ohCaseId = props.task.caseId;
        const taskId = props.task.id;
        return (
            <ActiveTaskAction task={props.task}>
                <Link href={`${actionableTasksRoute}/${customerId}/${ohCaseId}/${taskId}/createRecall`}>
                    <Button content="Create" floated="right" />
                </Link>
            </ActiveTaskAction>
        );
    }

    return (
        <ActiveTaskAction task={props.task}>
            <Link href={`${route}/${props.task.id}/createRecall`}>
                <Button content="Create" floated="right" />
            </Link>
            <CreateRecallModal customerId={props.task.customer.id} ohCaseId={props.task.caseId} taskId={props.task.id} open={isModalOpen} />
        </ActiveTaskAction>
    );
};
